import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import {
	Textarea,
	FormItem,
	Player,
	Button,
	Modal,
	Space,
	ParticipantSelect,
	ModalTitle,
} from '@components';

import {
	ConvertedDialogueAct,
} from '@common';

import './DialogueActModal.scss';
import { ParticipantInfo } from '@api';

interface DialogueActModalProps {
	onSubmit: (updatedDialogueAct: ConvertedDialogueAct) => void,
	dialogueAct: ConvertedDialogueAct,
	closeModal: () => void,
	accessToken: string,
}

function DialogueActModal(props: DialogueActModalProps): JSX.Element {
	const {
		dialogueAct: initialDialogueAct,
		closeModal,
		onSubmit,
		accessToken,
	} = props;

	const
		location = useLocation(),
		pathParts = location.pathname.split('/'),
		meetingId = pathParts[pathParts.length - 1];

	const
		[dialogueActText, setDialogueActText] = useState<string>(''),
		[dialogueAct, setDialogueAct] = useState<ConvertedDialogueAct>(initialDialogueAct),
		playerRef = useRef<HTMLVideoElement>(null);

	const suggestedPersons = useMemo(() => {
		return [new ParticipantInfo({ id: dialogueAct.data.speakerId, name: dialogueAct.data.name })];
	}, [dialogueAct]);

	const [selectedPersons, setSelectedPersons] = useState<ParticipantInfo[]>(suggestedPersons);

	useEffect(() => {
		setDialogueActText(initialDialogueAct.data.text);
		setDialogueAct(initialDialogueAct);
	}, [initialDialogueAct]);

	const onIsPlayingChanged = useCallback((/*isPlaying: boolean*/): void => {
		// setIsPlaying(isPlaying);
	}, [/*setIsPlaying*/]);

	const onPlayerTimeChanged = useCallback((/*seconds: number*/): void => {
		// seconds
	}, []);

	const handleSubmit = useCallback(() => {
		const updatedDialogueAct: ConvertedDialogueAct = {
			initialData: dialogueAct.initialData,
			isPlaying: false,
			isHighlighted: false,
			data: {
				...dialogueAct.data,
				text: dialogueActText,
				speakerId: selectedPersons[0].id,
				name: selectedPersons[0].name,
			},
		};

		onSubmit(updatedDialogueAct);
		closeModal();
	}, [onSubmit, closeModal, selectedPersons, dialogueAct.data, dialogueAct.initialData, dialogueActText]);

	const onDialogueActTextChange = useCallback((e): void => {
		setDialogueActText(e.target.value);
	}, [setDialogueActText]);

	const headerView = useMemo((): JSX.Element => {
		return (
			<div className="dialogue-act-modal__header">
				<ModalTitle onClose={closeModal}>
					Редактирование блока
				</ModalTitle>
			</div>
		);
	}, [closeModal]);

	const footerView = useMemo(() => {
		return (
			<Space>
				<Button theme="primary" onClick={handleSubmit} disabled={selectedPersons.length < 1}>
					Сохранить
				</Button>
				<Button onClick={closeModal}>
					Отменить
				</Button>
			</Space>
		);
	}, [handleSubmit, closeModal, selectedPersons]);

	return (
		<Modal
			className="dialogue-act-modal"
			header={headerView}
			footer={footerView}
			isOpen
		>
			<FormItem>
				<ParticipantSelect
					suggestedValues={suggestedPersons}
					values={selectedPersons}
					onChange={setSelectedPersons}
					maxValues={1}
					/>
			</FormItem>
			<FormItem>
				<Player
					mediaUrl={`/api/media/${meetingId}/audio?access_token=${accessToken}`}
					onIsPlayingChanged={onIsPlayingChanged}
					onTimeChanged={onPlayerTimeChanged}
					playerRef={playerRef}
					defaultStartTimeTicks={initialDialogueAct.data.timeTicks}
					defaultEndTimeTicks={initialDialogueAct.data.timeEndTicks}
				/>
			</FormItem>
			{/* <FormItem>
				<Space>
					<Button theme="ghost" size="nogap" disabled>
						Разделить
					</Button>
					<Button theme="ghost" size="nogap" disabled>
						Объединить
					</Button>
				</Space>
			</FormItem> */}
			<FormItem>
				<Textarea
					className="dialogue-act-modal__textfield"
					onChange={onDialogueActTextChange}
					placeholder="Текст блока"
					value={dialogueActText}
				/>
			</FormItem>
		</Modal>
	);
}

export {DialogueActModal};